import { createApiActionType } from 'app/store/utils';
import { GET_DBT_MODEL_INFO } from 'app/lib/types/server';

const apiType = createApiActionType('dbt');

export const GET_DBT_MODEL_INFO_ACTION_TYPE = apiType(GET_DBT_MODEL_INFO);
